import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { List } from 'foundations-components/transitional/components/List';
import { ListsIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { TeamOptionType } from '../types/OptionTypes';
import { getSortedFlattenedTeamsList } from '../utils/TeamUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TeamCheckbox = ({
  id,
  name,
  depth,
  checked,
  onRemoveTeam,
  onAddTeam,
  disabled
}) => {
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    paddingInlineStart: `${depth * 300}`,
    children: /*#__PURE__*/_jsx(Checkbox, {
      value: id,
      checked: checked,
      paddingInlineEnd: "100",
      disabled: disabled,
      "data-test-id": "team-checkbox",
      onChange: () => {
        if (checked) {
          onRemoveTeam(id);
        } else {
          onAddTeam(id);
        }
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        "data-test-id": `assign-team-checkbox-${id}`,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(ListsIcon, {}), /*#__PURE__*/_jsx(Text, {
          marginInlineStart: "200",
          children: name
        })]
      })
    })
  });
};
class SelectableTeamsList extends Component {
  constructor(...args) {
    super(...args);
    this.renderTeamCheckbox = ({
      depth,
      id,
      name
    }) => {
      const {
        selectedTeamIds = [],
        onAddTeam,
        onRemoveTeam,
        rootLevelTeamIds,
        userHasTeamAssignmentScope,
        allowedTeamIds,
        DisallowedTeamFormattedMessage
      } = this.props;
      const checked = selectedTeamIds.includes(id);
      const isRootLevelTeam = rootLevelTeamIds.includes(id);
      const isDisabled = isRootLevelTeam && checked && !userHasTeamAssignmentScope;
      const isTeamDisallowed = allowedTeamIds && !allowedTeamIds.includes(id);
      const key = `${id}-team-checkbox`;
      const checkbox = /*#__PURE__*/_jsx(TeamCheckbox, {
        id: id,
        name: name,
        depth: depth,
        checked: checked,
        disabled: isDisabled || isTeamDisallowed,
        onAddTeam: onAddTeam,
        onRemoveTeam: onRemoveTeam
      }, key);
      if (isDisabled || isTeamDisallowed) {
        return /*#__PURE__*/_jsx(Tooltip, {
          placement: "left",
          title: isTeamDisallowed ? /*#__PURE__*/_jsx(DisallowedTeamFormattedMessage, {
            teamId: id,
            teamName: name
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'ui-asset-management-lib.tooltips.disabledTeamTooltip'
          }),
          children: /*#__PURE__*/_jsx("span", {
            children: checkbox
          })
        }, key);
      }
      return checkbox;
    };
  }
  render() {
    const {
      teams
    } = this.props;
    const teamOptions = getSortedFlattenedTeamsList(teams);
    return /*#__PURE__*/_jsx(List, {
      children: teamOptions.map(team => this.renderTeamCheckbox({
        depth: team.depth || 0,
        id: team.id,
        name: team.name
      }))
    });
  }
}
SelectableTeamsList.propTypes = {
  teams: PropTypes.arrayOf(TeamOptionType).isRequired,
  selectedTeamIds: PropTypes.arrayOf(PropTypes.number),
  onAddTeam: PropTypes.func.isRequired,
  onRemoveTeam: PropTypes.func.isRequired,
  rootLevelTeamIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  userHasTeamAssignmentScope: PropTypes.bool.isRequired,
  allowedTeamIds: PropTypes.arrayOf(PropTypes.number),
  DisallowedTeamFormattedMessage: PropTypes.func
};
export default SelectableTeamsList;